export default __webpack_public_path__ + "resources/icons/d221-4ae1.png";